// 支払明細一覧内の定数

export const 車輌Bindings = ["車番", "トレーラ車番", "乗務員名", "運行部所名"]
export const 積卸地Bindings = ["積場社名", "積場地名", "卸場社名", "卸場地名"]
export const 品名Bindings = ["品コード", "品名", "数量", "単位区分名称"]
export const 請求額Bindings = [
  "請求運送料課税区分名称",
  "請求運送料",
  "請求付帯料課税区分名称",
  "請求付帯料",
  "請求高速料税込区分名称",
  "請求高速料",
  "請求額合計",
]
export const 支払額Bindings = [
  "支払運送料課税区分コード",
  "支払運送料",
  "支払付帯料課税区分コード",
  "支払付帯料",
  "支払高速料税込区分名称",
  "支払高速料",
  "支払額合計",
  "支払備考",
  "支払計上日",
  "支払額確認区分コード",
]
